import styled from 'styled-components/macro'
import { respondAbove } from 'styles/mediaQueries'
import SeparatedList from 'components/shared/SeparatedList'
import Text from 'components/shared/Text'

export const SummaryListWrapper = styled(SeparatedList)`
    background-color: ${({ theme }) => theme.colors.grayscale_0};
    border-radius: 8px;

    ${SeparatedList} {
        & > ${Text} {
            & + * {
                margin-top: 16px;
            }
        }
    }

    @media ${respondAbove.xl} {
        position: sticky;
        top: 24px;
        margin-top: 74px;
        margin-bottom: 244px;

        > div {
            padding: 16px 16px 0;
        }
    }
`
